import { IApiRequest } from "@miplatform/types";
import { SUBSCRIPTION_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_RECORD_PERMISSION = `${SUBSCRIPTION_SERVICE}/record-permissions`;

export const recordPermissions = {
  getAll: async ({ filters, sort, top, skip }: IApiRequest = {}) => {
    const options = await apiOptions({
      url: `${API_RECORD_PERMISSION}`,
      method: "get",
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
};
